module.exports = __webpack_public_path__ + "img/tunai.f2aa8973.svg";